import * as React from 'react';
import { useState } from 'react';

type ShopTheLookDialogContextType = {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  selectedItem: NordicNest.Api.ShopTheLookApiModel | null;
  setSelectedItem: React.Dispatch<React.SetStateAction<NordicNest.Api.ShopTheLookApiModel | null>>;
  title: string;
  setTitle: React.Dispatch<React.SetStateAction<string>>;
};

const shopTheLookDialogContext = React.createContext<ShopTheLookDialogContextType>({
  isOpen: false,
  setIsOpen: () => {},
  selectedItem: null,
  setSelectedItem: () => {},
  title: '',
  setTitle: () => {},
});

export function ShopTheLookDialogProvider({ children }: React.PropsWithChildren<{}>) {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState<NordicNest.Api.ShopTheLookApiModel | null>(null);
  const [title, setTitle] = useState<string>('');
  return (
    <shopTheLookDialogContext.Provider value={{ isOpen, setIsOpen, selectedItem, setSelectedItem, title, setTitle }}>
      {children}
    </shopTheLookDialogContext.Provider>
  );
}

export function useShopTheLookDialogContext() {
  return React.useContext(shopTheLookDialogContext);
}
